import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './langs/zh'
import en from './langs/en'

Vue.use(VueI18n)

const messages = {
  zh,
  en
}
const langsList = [{ values: [] }]
Object.keys(messages).forEach(item => {
  langsList[0].values.push({ text: `${messages[item].text}`, value: `${item}` })
})
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages
})

i18n.langsList = langsList
export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js